import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'bidStatus' })
export class BidStatusPipe implements PipeTransform {

    transform(value: Array<number>) {
        return this.bidStatus(value[0],value[1])
    }

    bidStatus(startsAt: number, endsAt: number) {
        var now = Date.now()
        if (now < startsAt) {

           return  this.startsIn(startsAt, endsAt)

        } else if (now > startsAt && now < endsAt) {

            return this.endsIn(startsAt, endsAt)

        } else {
            return this.ended()
        }
    }

    private startsIn(startsAt: number, endsAt: number) {

        var totalHours, totalMinutes, totalSeconds, hours, minutes, seconds, days;
        var diff = this.getTimeDifference(startsAt)
        var auctionStatus = ""

        totalSeconds = diff / 1000;
        totalMinutes = totalSeconds / 60;
        totalHours = totalMinutes / 60;
        days = Math.floor(totalHours / 24);

        seconds = Math.floor(totalSeconds) % 60;
        minutes = Math.floor(totalMinutes) % 60;
        hours = Math.floor(totalHours) % 60;

        if (days >= 1) {
            auctionStatus = `STARTS IN ${days} DAYS ${hours} HOURS`
        } else if (hours >= 1) {
            auctionStatus = `STARTS IN ${hours} HOURS ${minutes} MINUTES`
        } else {
            auctionStatus = `STARTS IN ${minutes} MINUTES ${seconds} SECONDS`
        }

        return auctionStatus
    }

    private endsIn(startsAt: number, endsAt: number) {

        var totalHours, totalMinutes, totalSeconds, hours, minutes, seconds, days;
        var diff = this.getTimeDifference(endsAt)
        var auctionStatus = ""

        totalSeconds = diff / 1000;
        totalMinutes = totalSeconds / 60;
        totalHours = totalMinutes / 60;
        days = Math.floor(totalHours / 24);

        seconds = Math.floor(totalSeconds) % 60;
        minutes = Math.floor(totalMinutes) % 60;
        hours = Math.floor(totalHours) % 24;

        if (days >= 1) {
            auctionStatus = `ENDS IN ${days} DAYS ${hours} HOURS`
        } else if (hours >= 1) {
            auctionStatus = `ENDS IN ${hours} HOURS ${minutes} MINUTES`
        } else {
            auctionStatus = `ENDS IN ${minutes} MINUTES ${seconds} SECONDS`
        }

        return auctionStatus
    }

    private ended() {
        return "Ended"
    }

    private getTimeDifference(time: number) {
        return time - Date.now()
    }
}